<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.2376 3.84459C11.7046 2.72173 13.2952 2.72173 13.7623 3.84459L15.931 9.05887L21.5603 9.51017C22.7725 9.60735 23.264 11.1202 22.3404 11.9113L18.0515 15.5852L19.3619 21.0784C19.644 22.2613 18.3572 23.1963 17.3193 22.5624L12.4999 19.6187L7.68048 22.5624C6.64265 23.1963 5.35578 22.2613 5.63795 21.0784L6.94828 15.5852L2.65938 11.9113C1.73579 11.1202 2.22733 9.60735 3.43955 9.51017L9.06881 9.05887L11.2376 3.84459Z" 
                :fill="color"
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgStar',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>